export default __webpack_public_path__ + "static/icon-14-2-94c3395385760d80079205d6f57bd215.png";